/**
 * SunIllustration/index.js
 * desc: sun illustration
 * note: stateless presentational component
 */
'use strict';

import { classNames } from '../../../utilities';
import './styles.css';

const SunIllustration = ({ className }) => {
    const classList = classNames('sun illustration', className);

    return (
        <figure className={ classList } > 
            <svg viewBox="0 0 138 138" xmlns="http://www.w3.org/2000/svg"><path d="M68.775 107.799c21.649 0 39.199-17.55 39.199-39.199 0-21.649-17.55-39.199-39.199-39.199-21.649 0-39.199 17.55-39.199 39.199 0 21.649 17.55 39.199 39.199 39.199z"/><path d="M30.998 30.823S13.122 12.947 13.778 13.61l17.22 17.212z"/><path d="M30.998 30.823S13.122 12.947 13.778 13.61"/><path d="M123.781 123.606s-17.876-17.876-17.22-17.212l17.22 17.212z"/><path d="M123.781 123.606s-17.876-17.876-17.22-17.212"/><path d="M106.518 30.823l17.246-17.203-17.246 17.203z"/><path d="M106.518 30.823l17.246-17.203"/><path d="M13.735 123.606l17.246-17.204-17.246 17.204z"/><path d="M13.735 123.606l17.246-17.204"/><path d="M15.344 68.6H.209h15.135z"/><path d="M15.344 68.6H.209"/><path d="M137.358 68.6h-15.135 15.135z"/><path d="M137.358 68.6h-15.135"/><path d="M68.775 15.177V0v15.177z"/><path d="M68.775 15.177V0"/><path d="M68.775 137.183v-15.135 15.135z"/><path d="M68.775 137.183v-15.135"/></svg>
        </figure>
    );
};


export default SunIllustration;
